import { Routes } from '@angular/router';
import { RoleGuard } from './core/guards/role.guard';
import { UserType } from './core/models/user';

export const appRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('./home/home.component').then(m => m.HomeComponent),
    canActivate: [RoleGuard],
    data: { roles: [UserType.SysAdmin, UserType.CustomerUser] },
  },
  {
    path: 'resetPassword/:secureString',
    loadComponent: () =>
      import('./reset-password-deep-link-redirect.component').then(m => m.ResetPasswordDeepLinkRedirectComponent),
  },
  { path: 'account', loadChildren: () => import('./account/account.routes').then(m => m.accountRoutes) },
  {
    path: 'admin',
    loadChildren: () => import('./admin-panel/admin-panel.routes').then(m => m.adminPanelRoutes),
    canActivate: [RoleGuard],
    data: { roles: [UserType.SysAdmin, UserType.CustomerUser] },
  },
  {
    path: 'invoice',
    loadChildren: () => import('./invoice-manager/invoice-manager.routes').then(m => m.invoiceManagerRoutes),
    canActivate: [RoleGuard],
    data: { roles: [UserType.SysAdmin, UserType.CustomerUser] },
  },
  {
    path: 'product',
    loadChildren: () => import('./products/product.routes').then(m => m.productRoutes),
    canActivate: [RoleGuard],
    data: { roles: [UserType.SysAdmin, UserType.CustomerUser] },
  },
  {
    path: 'project',
    loadChildren: () => import('./project/project.routes').then(m => m.projectRoutes),
    canActivate: [RoleGuard],
    data: { roles: [UserType.SysAdmin, UserType.CustomerUser, UserType.DeveloperUser] },
  },
  {
    path: 'purchases',
    loadChildren: () => import('./purchases/purchases.routes').then(m => m.purchasesRoutes),
    canActivate: [RoleGuard],
    data: {
      roles: [
        UserType.SysAdmin,
        UserType.CustomerUser,
        UserType.DeveloperUser,
        UserType.TimeReportingUser,
        UserType.PunchClockUser,
        UserType.ProductUpdator,
      ],
    },
  },
  {
    path: 'supplier-invoices',
    loadChildren: () => import('./supplier-invoices/supplier-invoices.routes').then(m => m.supplierInvoicesRoutes),
    canActivate: [RoleGuard],
    data: { roles: [UserType.SysAdmin, UserType.DeveloperUser, UserType.ProductUpdator] },
  },
  {
    path: 'reports',
    loadChildren: () => import('./reports/reports.routes').then(m => m.reportsRoutes),
    canActivate: [RoleGuard],
    data: { roles: [UserType.SysAdmin, UserType.DeveloperUser, UserType.ProductUpdator] },
  },
  {
    path: 'time',
    loadChildren: () => import('./time/time.routes').then(m => m.timeRoutes),
    canActivate: [RoleGuard],
    data: {
      roles: [
        UserType.SysAdmin,
        UserType.CustomerUser,
        UserType.DeveloperUser,
        UserType.ProductUpdator,
        UserType.TimeReportingUser,
        UserType.PunchClockUser,
      ],
    },
  },
  {
    path: 'customers',
    loadChildren: () => import('./customers/customers.routes').then(m => m.customersRoutes),
    canActivate: [RoleGuard],
    data: { roles: [UserType.SysAdmin, UserType.DeveloperUser, UserType.ProductUpdator] },
  },
  {
    path: 'time-registration',
    loadChildren: () =>
      import('./project/time-registration/time-registration.routes').then(m => m.timeRegistrationRoutes),
    canActivate: [RoleGuard],
    data: { roles: [UserType.SysAdmin, UserType.CustomerUser, UserType.PunchClockUser, UserType.TimeReportingUser] },
  },
  { path: 'punch-clock', redirectTo: 'time-registration', pathMatch: 'prefix' },
  { path: 'time-registration/tid-profil', redirectTo: 'time/min', pathMatch: 'full' },
  { path: 'time-registration/plats-valjare', redirectTo: 'time/plats', pathMatch: 'full' },
  { path: 'time-registration/klocka/:id', redirectTo: 'time/plats/:id' },
  { path: 'time-registration/resa/:tripId', redirectTo: 'time/resa/:tripId' },
  { path: '**', redirectTo: '' },
];
